import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import { group } from '@editor/src/js/constants/toolbar-data';
import { wrapIdForCommon } from '@framework/workbench/util/wrap-id-util';
import ADD_GROUP_ICON from '@src/img/first-screen/addGroup.svg';

export const config = group;

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={ADD_GROUP_ICON} alt={''}/>,
        tooltip: config.tipMsg,
    },
    {
        name: wrapIdForCommon(config.id),
        hasArrow: true,
        text: config.title,
        icon: <img src={ADD_GROUP_ICON} alt={''}/>,
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
            maxWidth: 62,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.tipMsg,
        preventDismiss: true,
    },
];
